import React from 'react'

export const TheWestMiniStarIcon = ({ index }: { index: number }) => (
    <div
        style={
            index === 1
                ? { position: 'absolute', right: '34%', top: 38 }
                : { position: 'absolute', right: '36%', top: 76 }
        }
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            aria-hidden="true"
        >
            <path
                d="M10.2671 0.514202C10.3218 0.363529 10.4216 0.233348 10.5528 0.14135C10.6841 0.0493525 10.8405 0 11.0008 0C11.1611 0 11.3175 0.0493525 11.4487 0.14135C11.58 0.233348 11.6797 0.363529 11.7344 0.514202L12.4806 2.55283C13.0658 4.15098 13.9923 5.60234 15.1958 6.80578C16.3992 8.00922 17.8506 8.93581 19.4487 9.52098L21.4858 10.2671C21.6365 10.3218 21.7667 10.4216 21.8587 10.5528C21.9506 10.6841 22 10.8405 22 11.0008C22 11.1611 21.9506 11.3175 21.8587 11.4487C21.7667 11.58 21.6365 11.6797 21.4858 11.7344L19.4487 12.4806C17.8506 13.0658 16.3992 13.9923 15.1958 15.1958C13.9923 16.3992 13.0658 17.8506 12.4806 19.4487L11.7344 21.4858C11.6797 21.6365 11.58 21.7667 11.4487 21.8587C11.3175 21.9506 11.1611 22 11.0008 22C10.8405 22 10.6841 21.9506 10.5528 21.8587C10.4216 21.7667 10.3218 21.6365 10.2671 21.4858L9.52098 19.4487C8.93581 17.8506 8.00922 16.3992 6.80578 15.1958C5.60234 13.9923 4.15098 13.0658 2.55283 12.4806L0.514202 11.7344C0.363529 11.6797 0.233348 11.58 0.14135 11.4487C0.0493525 11.3175 0 11.1611 0 11.0008C0 10.8405 0.0493525 10.6841 0.14135 10.5528C0.233348 10.4216 0.363529 10.3218 0.514202 10.2671L2.55283 9.52098C4.15098 8.93581 5.60234 8.00922 6.80578 6.80578C8.00922 5.60234 8.93581 4.15098 9.52098 2.55283L10.2671 0.514202Z"
                fill="#DFE7FF"
            />
        </svg>
    </div>
)
